import { ApiModule } from "@packages/common";
import { Module } from "@webmotors/ioc";
import { SearchService } from "./search.service";

export const SearchModule: Module = {
  name: "SearchModule",
  modules: [ApiModule],
  providers: [SearchService],
};
